export const environment = {
  apiUrl: 'https://bmza7k37z4.execute-api.eu-west-3.amazonaws.com/v1/',
  label: 'Dev',
  auth: {
    authority: 'https://cognito-idp.eu-west-3.amazonaws.com/eu-west-3_6XBulpzDA',
    redirectUrl: globalThis.location.origin,
    clientId: '1fkr9u3pfq6so2khkcvr2d82gs',
    scope: 'openid',
    responseType: 'code',
    logoutUrl: 'https://sunleon-dev-user-pool-app.auth.eu-west-3.amazoncognito.com/logout'
  },
  sharePoint: {
    clientId: 'afa4279a-b762-41e5-b367-25f87eb017c3',
    tenantId: 'f48f023f-f1f2-4a42-92aa-bebb215f31d0',
    siteUrl: 'https://workplaceenergy.sharepoint.com/sites/Sunleon_Dev',
    defaultFolderPath: 'Documents partages/genslides_dev'
  }
};
